import React from 'react';

/**
 * CompanySidebar - Seitenleiste zur Anzeige von Unternehmensinformationen.
 *
 * @param {Object} props - Props der Komponente.
 * @param {Object} props.company - Das anzuzeigende Unternehmen.
 * @param {Function} props.onClose - Funktion zum Schließen der Seitenleiste.
 * @returns {JSX.Element} - Die gerenderte Seitenleiste.
 */
const CompanySidebar = ({ company, onClose }) => {
  if (!company) return null;

  return (
    <div className="sidebar right-sidebar">
      <div className="sidebar-header">
        <h3>Unternehmensinformationen</h3>
        <button className="close-sidebar" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="sidebar-content">
        <p>
          <strong>Name:</strong> {company.name}
        </p>
        <p>
          <strong>Branche:</strong> {company.sector || 'Nicht angegeben'}
        </p>
        <p>
          <strong>Adresse:</strong> {company.address || 'Nicht angegeben'}
        </p>
        <p>
          <strong>Telefon:</strong> {company.phone || 'Nicht angegeben'}
        </p>
        <p>
          <strong>E-Mail:</strong> {company.email || 'Nicht angegeben'}
        </p>
        <p>
          <strong>Website:</strong> {company.website || 'Nicht angegeben'}
        </p>
        <p>
          <strong>Bemerkungen:</strong> {company.remarks || 'Keine'}
        </p>
        <p>
          <strong>Status:</strong> {company.active ? 'Aktiv' : 'Inaktiv'}
        </p>
        <p>
          <strong>Hervorgehoben:</strong> {company.highlighted ? 'Ja' : 'Nein'}
        </p>
      </div>
    </div>
  );
};

export default CompanySidebar;